import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Page } from "../../Page";
import { useEffect } from "react";
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setPromptOkCancelOnHome } from "../menu/menuSlice";
import styles from'./EventTaskWizard.module.css'
import { selectCurrentEventTaskStatus, selectCurrentNotes, selectProgressionStatus, setNotes, setProgressionStatus, storeEventTaskAsync } from "../currentEventTask/currentEventTaskSlice";
import { MessageBoxAction, setMessage, setMessageBoxAction } from "../messageBoxes/messageBoxSlice";
import { useAuth0 } from "@auth0/auth0-react"
import { sanitizeEmail } from "../../utils/emailUtils";
import { renderStatus } from "../../utils/enumUtils";
import { BackButton } from "../menu/BackButton";

export function Notes() {
    const notes = useAppSelector(selectCurrentNotes)
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const currentEventTaskStatus = useAppSelector(selectCurrentEventTaskStatus)
    const progressionStatus = useAppSelector(selectProgressionStatus)
    
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setPromptOkCancelOnHome(true))
        dispatch(setMessage('Cancel saving this task and return to the home page?'))
      }, [dispatch]);
    return (
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.header}>
            <h1>PartyPlanner</h1>
            <br></br>
            <h2>Notes</h2>
            <p>This is for any extra details you want people to know about for this task</p>
            </div>
            <br></br>
            <label className={styles.label} htmlFor='txtNotes'>Notes:</label>
            <input
                placeholder="Type notes here"
                id='txtNotes'
                className={styles.textbox}
                aria-label='Set Notes'
                value={notes}
                onChange={(e) => dispatch(setNotes(e.target.value))}
            />

            <label className={styles.label} htmlFor='selectStatus'>Status:</label>
            <select 
                value={progressionStatus}
                id= 'selectStatus'     
                className={styles.dropdown}
                onChange={(e) => {
                    dispatch(setProgressionStatus(parseInt(e.target.value))
                    )}}>
                        <option value={0}>{renderStatus(0)}</option>
                        <option value={1}>{renderStatus(1)}</option>
                        <option value={2}>{renderStatus(2)}</option>
                        <option value={3}>{renderStatus(3)}</option>
                        </select>

<div className={styles.controlButtons}>
            <button className={styles.cancelButton} onClick={()=> {
                let msg3 = `Are you sure you want to cancel creating this task?`
                dispatch(setMessage(msg3))
                dispatch(setMessageBoxAction(MessageBoxAction.GoToCurrentsPartyEvents))
                navigate('/MessageBox')
            }}> Cancel</button>
            
            <button className={styles.saveButton} onClick={async () => {
            if (isAuthenticated && user?.email) { 
                
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                    dispatch(storeEventTaskAsync( { 
                        token: accessToken,
                        userEmail: sanitizeEmail(user?.email)
                        }))
                    if (currentEventTaskStatus === 'idle') {
                        navigate('/currentPartyEvent')
                    } else {
                        alert (`Not expected status '${ currentEventTaskStatus }'`)
                    }
            }
        }}>
            Save
        </button>
        </div>
        </Page>
    )
}